import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles((theme) => ({
    root: {}
}));

const ItemProductAdmin = props => {

    const classes = useStyles();
    const theme = useTheme();

    return (
        <>

            <TableRow key={props.product.index}>
                <TableCell component="th" scope="props.client">
                    {props.product.description}
                </TableCell>
                <TableCell align="left">{parseFloat(props.product.value).toLocaleString('pt-BR',{style: 'currency', currency:'BRL'})}</TableCell>
                <TableCell align="left">
                    {props.product.nameMarina}
                </TableCell>
            </TableRow>

        </>
    );

}

export default ItemProductAdmin;